/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1DayOfWeek } from '../models/V1DayOfWeek';
import { HttpFile } from '../http/http';

/**
* WeeklyFrequencyConfig holds settings that apply when frequency = WEEKLY.
*/
export class V1WeeklyFrequencyConfig {
    /**
    * One or more days of the week. Required (non-empty).
    */
    'daysOfWeek': Array<V1DayOfWeek>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "daysOfWeek",
            "baseName": "days_of_week",
            "type": "Array<V1DayOfWeek>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1WeeklyFrequencyConfig.attributeTypeMap;
    }

    public constructor() {
    }
}

